<mat-card class="proj-view-cont">
    <div class="proj-view-head">
        <app-library-item-header (unpinLibrary)="unpinLibrary()" (closeLibrary)="closeLibrary()"
            [title]="'PROJECT' | translate"></app-library-item-header>
    </div>
    <mat-card-content class="p-0 proj-view-card">
        <div class="proj-view-container">
            <div class="proj-view-body">
                <div class="tree-header">
                    <div class="header-column column-status" [style.width]="statusColumnWidth">
                        <span class="column-label"></span>
                    </div>
                    <div class="header-column column-actions" [style.width]="actionsColumnWidth">
                        <span class="column-label"></span>
                    </div>
                </div>
                <mat-tree #projectTree [dataSource]="treeData" [childrenAccessor]="childrenAccessor" class="project-tree">
                    <!-- Hide Controller and DesigoOptic nodes -->
                    <mat-tree-node *matTreeNodeDef="let node; when: isControllerOrDesigoOptic"  class="hidden-node">
                    </mat-tree-node>
                    <!-- Show other leaf nodes -->
                        <mat-tree-node *matTreeNodeDef="let node" [ngClass]="{'typical-off-node': node.hasTypicalOf && !node.isTypicalOffExpanded}" matTreeNodePadding [matTreeNodePaddingIndent]="30" (dblclick)="onNodeDoubleClick(node)">
                          <div class="node-content d-flex w-100">
                            <div class="node-name-column">   
                                <div class="mat-tree-node w-100 gap-2" [ngClass]="node.isItemVisible ? '' : 'disabled-node'">
                                    <img class="tree-icon" [src]="getLeafNodeIcon(node)" alt="">
                                    <span *ngIf="node.hasTypicalOf">{{ node.typicalOfCount }}</span>
                                    <span *ngIf="!node.isInEditMode" matTooltip="{{ node.itemName }}" class="node-content-text">{{ node.itemName }}</span>
                                    <span *ngIf="node.isInEditMode">
                                        <input #nodeInput type="text" matInput [value]="node.itemName"
                                            (blur)="saveNodeName(node, nodeInput.value)"
                                            (keydown.enter)="saveNodeName(node, nodeInput.value)" autofocus />
                                    </span>
                                </div>
                            </div>
                            <div class="node-status-column">
                            <div>
                                <img *ngIf="getDesigoCCInfo(node) as desigoCCImageSrc" 
                                        class="tree-icon" 
                                        [src]="desigoCCImageSrc" 
                                        [alt]="">
                            </div>
                            </div>
                            <div class="node-actions-column">
                            <button mat-icon-button (click)="toggleNodeVisibility(node)" [class.readonly-action]="isReadOnlyMode" [attr.aria-disabled]="isReadOnlyMode" [matTooltip]="'SHOW_HIDE' | translate" [matTooltipPosition]="'right'">
                                @if(node.isItemVisible) {
                                    <mat-icon class="show-hide-icon">visibility</mat-icon>
                                } @else {
                                    <mat-icon class="show-hide-icon hide-icon">lens</mat-icon>
                                }
                            </button>
                            </div>
                        </div>
                    </mat-tree-node>
                    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" [ngClass]="{'typical-off-node': node.hasTypicalOf && !node.isTypicalOffExpanded}" matTreeNodePadding [matTreeNodePaddingIndent]="20"
                        (dblclick)="onNodeDoubleClick(node)">
                        <div class="node-content d-flex w-100">
                            <div class="node-name-column">
                        <div class="mat-tree-node w-100 gap-2" [ngClass]="node.isItemVisible ? '' : 'disabled-node'" [class.selectProject]="isEstimateTab && node.nodeType !== nodeType.Area" [class.project-node]="node.nodeType !== nodeType.Area">
                            <button mat-icon-button (click)="toggleNodeExpansion(node)" [attr.aria-label]="'Toggle ' + node.itemName">
                                <mat-icon class="mat-icon-rtl-mirror">
                                    {{projectTree.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                </mat-icon>
                            </button>
                                <img class="tree-icon" [src]="getParentNodeIcon(node)" alt="Tree Icon">
                            <span *ngIf="node.hasTypicalOf">{{ node.typicalOfCount }}</span>
                            <span *ngIf="!node.isInEditMode" [matTooltip]="node.itemName" class="node-content-text" >{{node.itemName}}</span>
                            <span *ngIf="node.isInEditMode">
                                <input #nodeInput type="text" matInput [value]="node.itemName"
                                    (blur)="saveNodeName(node, nodeInput.value)"
                                    (keydown.enter)="saveNodeName(node, nodeInput.value)" autofocus />
                            </span>
                        </div>
                        </div>
                        <div class="node-status-column">
                        <div>
                           <img *ngIf="getControllerInfo(node) as controllerImageSrc" 
                                class="tree-icon" 
                                [src]="controllerImageSrc" 
                                [alt]="">
                           <img *ngIf="getDesigoOpticInfo(node) as desigoOpticImageSrc" 
                           class="tree-icon" 
                           [src]="desigoOpticImageSrc" [alt]="">
                        </div>
                        </div>
                        <div class="node-actions-column">
                        <button mat-icon-button (click)="toggleNodeVisibility(node)" [class.readonly-action]="isReadOnlyMode" [attr.aria-disabled]="isReadOnlyMode" [matTooltip]="'SHOW_HIDE' | translate" [matTooltipPosition]="'right'">
                            @if(node.isItemVisible) {
                                <mat-icon class="show-hide-icon">visibility</mat-icon>
                            } @else {
                                <mat-icon class="show-hide-icon hide-icon">lens</mat-icon>
                            }
                        </button>
                        </div>
                        </div>
                    </mat-tree-node>
                </mat-tree>
            </div>
            <div class="proj-view-footer">
                <div class="footer-left-btns">
                    <span class="typical-off-icons" *ngIf="isAllTypicalOffExpanded" [matTooltip]="'COLLAPSE_TYPICAL_OF' | translate">
                        <img src="assets/images/ShowTypical.gif" alt="" (click)="collapseTypicalOff()">
                    </span>
                    <span class="typical-off-icons" *ngIf="!isAllTypicalOffExpanded" [matTooltip]="'EXPAND_TYPICAL_OF' | translate">
                        <img src="assets/images/CollapseTypical.gif" alt=""  (click)="expandTypicalOff()">
                    </span>
                </div>
                <div class="footer-right-btns d-none">
                    <button mat-icon-button>
                        <mat-icon class="add-icon">keyboard_arrow_up</mat-icon>
                    </button>
                    <button mat-icon-button>
                        <mat-icon class="add-icon">keyboard_arrow_down</mat-icon>
                    </button>
                    <button mat-icon-button>
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>